export const PUNCHLINE_LOADING_PHASES = [
  'Calculating your path to financial ruin…',
  'Loading bagholding history…',
  'Consulting the theta decay gods…',
  'Stress-testing your resolve…',
  'Locating your exit strategy…',
  'Preparing the tax loss harvesting report…',
  'Estimating margin call timing…',
  'Blaming market conditions, not the algorithm…',
  'Generating impressively large drawdowns…',
  'Assembling the volatility excuse inventory…',
  'Checking if your broker accepts tears as collateral…',
  'Preparing the "it\'s a long-term hold" speech…',
  'Running the numbers (you won\'t like them)…',
  'Confirming the market is still not rational…',
  'Computing maximum drawdown velocity…',
  'Counting how many crayons you\'ve eaten this quarter…',
  'Loss porn rendering at 4K…',
  'Asking the loss tracker bot to be gentle…',
  'Calculating the wife\'s boyfriend\'s expected return…',
  'Polling r/wallstreetbets for due diligence…',
  'Confirming GUH probability…',
  'Translating your portfolio into Robinhood emoji…',
  'Loading guh.jpg into memory…',
  'Checking if SPY printed yet…',
  'Assembling exit liquidity…',
  'Reminding you that puts are calls on the inverse…',
  'Awakening the theta vampire…',
  'Letting the gamma cook…',
  'Asking IV to please crush gently…',
  'Mortgaging vega for one more contract…',
  'Buying calls 0DTE because we\'re already here…',
  'Negotiating with the market maker (he\'s not budging)…',
  'Pricing in the IV crush you forgot about…',
  'Watching theta eat your premium in real time…',
  'Selling the kidney with the better risk profile…',
  'Updating your obituary with portfolio performance…',
  'Asking your therapist to extend office hours…',
  'Drafting the explanation to your spouse…',
  'Calculating ramen-per-share runway…',
  'Computing how long until you\'re back at your old job…',
  'Estimating distance to the bridge…',
  'Adding "options trader" to your resume\'s Skills section…',
  'Refreshing your Wendy\'s application…',
  'Translating losses into hours of overtime…',
  'Counting the days until rent…',
  'It\'s not a loss until you sell…',
  'Adjusting cost basis with vibes…',
  'Marking to fantasy…',
  'Averaging down into oblivion…',
  'Diamond-handing through the bankruptcy filing…',
  'Writing the "this time is different" essay…',
  'Reframing the drawdown as a buying opportunity…',
  'Convincing yourself the chart is bullish actually…',
  'Drawing a trendline through the wreckage…',
  'Backfitting until profitable…',
  'P-hacking in progress…',
  'Overfitting to 2021 because it felt good…',
  'Asking the algorithm if it\'s sure…',
  'Cherry-picking the favorable backtest window…',
  'Hiding the 2022 results behind a button…',
  'Discovering survivorship bias (again)…',
  'Pretending Sharpe ratio still means something…',
  'Bribing the random number generator…',
  'Front-running your own backtest…',
  'Asking ChatGPT for stock tips…',
  'Consulting the magic 8-ball (it said "outlook not so good")…',
  'Reading tea leaves on the candlestick chart…',
  'Sacrificing a bull to the market gods…',
  'Praying to Jerome Powell…',
  'Waiting for the Fed pivot that never comes…',
];

export function shuffledPunchlineLoadingPhases() {
  const shuffled = [...PUNCHLINE_LOADING_PHASES];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
